"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _index = _interopRequireWildcard(require("../@i18n/index"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _ChatWindow = _interopRequireDefault(require("./ChatWindow"));
var _common = require("../@api/common");
var _store = require("../@api/store");
var _Input = _interopRequireDefault(require("./Input"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/// GROUP CHAT based on appcenter groups

var Chatbar = function Chatbar(_ref) {
  var visible = _ref.visible,
    setVisible = _ref.setVisible,
    appcenterStore = _ref.appcenterStore,
    windowFocused = _ref.windowFocused;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    chatWindows = _useState2[0],
    setChatwindows = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    maximized = _useState4[0],
    setMaximized = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    userSearch = _useState6[0],
    setUserSearch = _useState6[1];
  var _useState7 = (0, _react.useState)(''),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    groupSearch = _useState8[0],
    setGroupSearch = _useState8[1];
  var openChatWindowFromGroup = function openChatWindowFromGroup(group) {
    return function () {
      _store.services.appcenter.users.chats.createFromGroup(group);
      setVisible(false);
    };
  };
  var openChatWindowFromUser = function openChatWindowFromUser(user) {
    return function () {
      _store.services.appcenter.users.chats.createFromUser(user);
      setVisible(false);
    };
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    id: "chatbar",
    className: "".concat(visible ? 'visible' : 'hidden')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "header-line"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "title"
  }, (0, _index["default"])('message.central')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "action",
    onClick: function onClick(e) {
      setVisible(false);
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faTimesCircle"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "groups chats"
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    label: (0, _index["default"])('your.groups'),
    onChange: function onChange(e) {
      return setGroupSearch(e.target.value);
    },
    rightIcon: "faSearch"
  }), appcenterStore.groups.filter(function (o) {
    if (!groupSearch) return true;
    return JSON.stringify(o).indexOf(groupSearch) > -1;
  }).map(function (group) {
    if (group.members.indexOf(appcenterStore.user.uid) == -1) return;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "chat group",
      key: group.uid,
      onClick: openChatWindowFromGroup(group)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "icon"
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "faUsers"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "chat-name"
    }, group.name));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "users chats"
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    label: (0, _index["default"])('your.colleagues'),
    onChange: function onChange(e) {
      return setUserSearch(e.target.value);
    },
    rightIcon: "faSearch"
  }), appcenterStore.users.filter(function (o) {
    if (!userSearch) return true;
    return JSON.stringify(o).indexOf(userSearch) > -1;
  }).map(function (user) {
    if (user.uid === appcenterStore.user.uid) return;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "chat user",
      key: user.uid,
      onClick: openChatWindowFromUser(user)
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "icon"
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "faUser"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "chat-name"
    }, user.firstName + ' ' + user.lastName));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "chat-panels ".concat(visible ? 'chat-panels-visible' : 'chat-panels-hidden')
  }, appcenterStore.chats.sort(function (a, b) {
    var da = (0, _common.toDate)(a.createdAt),
      db = (0, _common.toDate)(b.createdAt);
    if (da > db) return 1;
    if (da < db) return -1;
    return 0;
  }).map(function (chat) {
    return /*#__PURE__*/_react["default"].createElement(_ChatWindow["default"], {
      key: chat.uid,
      windowFocused: windowFocused,
      maximized: maximized,
      setMaximized: setMaximized,
      chat: chat,
      appcenterStore: appcenterStore
    });
  })));
};
var _default = Chatbar;
exports["default"] = _default;